import React from 'react';
import DocumentTitle from 'react-document-title';

import { hasRole } from 'shared/models/user';

import { AgentEmailMatches } from '../components/agent-email-matches';
import { Header } from '../components/header';
import { useSession } from '../hooks/use-session';

export const AgentEmailMatchesPage: React.FC = () => {
    const { userPermissions } = useSession();
    if (!hasRole(userPermissions, 'email_match_setter')) return null;
    return (
        <DocumentTitle title="Agent Email Matches">
            <div id="container">
                <Header title="Agent Email Matches" />
                <div id="content" className="flex-fill">
                    <AgentEmailMatches />
                </div>
            </div>
        </DocumentTitle>
    );
};
